import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAddAssignmentMutation } from "../../../features/Assignments/assignmentsApi";
import { useGetVideosQuery } from "../../../features/Videos/videosApi";
import routes from "../../../config/routeConfig";
import AssignmentForm from "./AssignmentForm";

const initialState = {
  title: "",
  totalMark: 0,
};

export default function AddAssignmentForm() {
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState(initialState);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const { data: videos } = useGetVideosQuery();

  const [addAssignment, { isSuccess, isError, error }] =
    useAddAssignmentMutation();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formValues.totalMark <= 0) {
      alert("Please enter a valid total mark!");
      return;
    }

    addAssignment({
      ...formValues,
      totalMark: +formValues.totalMark,
      video_id: selectedVideo.id,
      video_title: selectedVideo.title,
    });
  };

  useEffect(() => {
    if (isSuccess) {
      setFormValues(initialState);
      navigate(routes.admin.assignments, { replace: true });
    } else if (isError) {
      alert(error?.data);
    }
  }, [isError, isSuccess]);

  return (
    <AssignmentForm
      handleSubmit={handleSubmit}
      setSelectedVideo={setSelectedVideo}
      selectedVideo={selectedVideo}
      setFormValues={setFormValues}
      formValues={formValues}
      videos={videos}
    />
  );
}
